import React from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { BodyM } from 'components/Typography/Typography';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import styles from 'assets/jss/material-dashboard-pro-react/views/billingPaymentTrack/uploadedFileStyle';
import { makeStyles } from '@material-ui/core';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUploadedFileProps {
	name: string;
	removeEntry: () => void;
	showPreview?: () => void;
}

const UploadedFile = ({ name, removeEntry, showPreview }: IUploadedFileProps) => {
	const classes = useStyles();
	return (
		<div className={classes.uploadSingleFile}>
			<div className={classes.checkIcon}>
				<CheckCircleOutlineIcon />
			</div>
			<div className={classes.uploadProofSingleFileText}>
				<BodyM>{name}</BodyM>
			</div>
			<div className={classes.iconsWrapper}>
				<div className={classes.icon}>
					<DeleteOutlineIcon onClick={removeEntry} />
				</div>
				<ConditionalRender
					show={!!showPreview}
					onTrue={() => (
						<div className={classes.icon}>
							<VisibilityOutlinedIcon onClick={showPreview} />
						</div>
					)}
				/>
			</div>
		</div>
	);
};

export default UploadedFile;
